import React from 'react';
import TestPipelineButton from './TestPipelineButton';

export default function StatusTableActions() {
  return <TestPipelineButton />;
}
